import React, { useEffect, useCallback } from 'react';
import { useUserSync } from '@/hooks';
import { useAuth } from '@/hooks';
import { authEvents } from '@/services/authEvents';

/**
 * Component to handle user data synchronization and permission refresh events
 */
export const UserSyncProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // This hook will automatically sync user data when needed
  useUserSync();

  const { refreshUserPermissions } = useAuth();

  // Handle permission refresh events
  const handlePermissionRefresh = useCallback(async () => {
    try {
      console.log('Refreshing user permissions due to API authorization error...');
      await refreshUserPermissions();
      console.log('User permissions refreshed successfully');
    } catch (error) {
      console.error('Failed to refresh user permissions:', error);
      // The API interceptor will handle the redirect to unauthorized page
    }
  }, [refreshUserPermissions]);

  useEffect(() => {
    // Listen for permission refresh events from API interceptor
    authEvents.on('refreshPermissions', handlePermissionRefresh);

    // Cleanup listener on unmount
    return () => {
      authEvents.off('refreshPermissions', handlePermissionRefresh);
    };
  }, [handlePermissionRefresh]);

  return <>{children}</>;
};
